var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 146,
    viewBox: "0 0 169 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8764 137.044C21.5964 137.044 8.72037 124.168 8.72037 107.74C8.72037 91.46 21.5964 78.584 37.8764 78.584C46.4604 78.584 54.3044 82.284 60.8164 89.832L66.8844 84.8C58.8924 75.476 48.5324 70.74 37.8764 70.74C17.7484 70.74 0.876374 87.612 0.876374 107.74C0.876374 128.016 17.7484 144.888 37.8764 144.888C48.5324 144.888 58.8924 140.004 66.8844 130.828L60.8164 125.648C54.3044 133.344 46.4604 137.044 37.8764 137.044ZM130.112 71.48C116.052 71.48 103.62 79.324 99.7716 85.836V0.735992H91.9276V145.48H99.7716V109.664C99.7716 92.644 113.24 79.324 130.112 79.324C147.132 79.324 160.452 92.644 160.452 109.664V145.48H168.444V109.664C168.444 88.796 150.98 71.48 130.112 71.48Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/CH.73601502233cccb884e9e0d5e9472a0a.svg";
export { ForwardRef as ReactComponent };